import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { paymentSelector, profileSelector, appSelector, paymentListSelector } from '../../selectors';
import * as paymentActions from '../../actions/paymentActions';
import * as policyActions from '../../actions/policyActions';
import Section from '../../components/Section';
import { Confirm } from 'semantic-ui-react';
import AccountPayment from '../../external-components/payments/account/AccountPayment';
import PaymentLists from '../../components/sections/payment/PaymentLists';
import PastPaymentInformation from '../../components/sections/payment/PastPaymentInformation';
import PaymentMenu from '../../components/sections/payment/PaymentMenu';
import RecurringPayments from '../../components/sections/payment/RecurringPayments';
import RecurringPayment from '../../components/sections/payment/recurring/RecurringPayment';
import Wallets from '../../components/sections/payment/Wallets';
import ScheduledPayments from '../../components/sections/payment/ScheduledPayments';

class PaymentSection extends Component {
	constructor(props) {
		super(props);
		const { payment } = props;
		const { policies } = payment;
		const defaultPolicy = policies && policies.length ? policies[0] : {};
		this.state = {
			activeMenuItem: 'policies',
			selectedPastPaymentPolicy: defaultPolicy,
			showMakePayment: false,
			showRecurringPayment: false,
			recurringPaymentData: null,
			showRemoveRecurring: false,
			removeRecurringData: null,
			loading: false,
			showRemoveSuccess: false,
			disabled: false,
			showCantChangeRecurring: false,
			isFuture: false,
		};
		this.onMenuItemClick = this.onMenuItemClick.bind(this);
		this.onPastPaymentListItmeClick = this.onPastPaymentListItmeClick.bind(this);
		this.onAddRecurringPaymentClick = this.onAddRecurringPaymentClick.bind(this);
		this.onEditRecurringPaymentClick = this.onEditRecurringPaymentClick.bind(this);
		this.onRemoveRecurringPaymentClick = this.onRemoveRecurringPaymentClick.bind(this);
		this.onRemoveRecurringPaymentContinue = this.onRemoveRecurringPaymentContinue.bind(this);
		this.onRecurringPaymentClose = this.onRecurringPaymentClose.bind(this);

		this.onRemoveRecurringPaymentCancel = this.onRemoveRecurringPaymentCancel.bind(this);
		this.onFinishRemoveRecurringPayment = this.onFinishRemoveRecurringPayment.bind(this);
		this.onCloseCantChangeRecurring = this.onCloseCantChangeRecurring.bind(this);
	}

	componentDidMount() {
		const { actions } = this.props;
		actions.getPaymentSettings();
	}

	componentDidUpdate(prevProps, prevState) {
		const { deepLink } = this.props;
		const { selectedPastPaymentPolicy } = this.state;
		if (!selectedPastPaymentPolicy.id && prevProps.payment !== this.props.payment) {
			const { payment } = this.props;
			const { policies } = payment;
			const defaultPolicy = policies && policies.length ? policies[0] : {};
			this.setState({ selectedPastPaymentPolicy: defaultPolicy });
		}
		if (selectedPastPaymentPolicy.id && prevProps.payment !== this.props.payment) {
			const { payment } = this.props;
			const { policies } = payment;
			const defaultPolicy = policies && policies.length ? policies[0] : {};
			this.setState({ selectedPastPaymentPolicy: defaultPolicy });
		}

		if(deepLink && deepLink.action === "paynow") {
			this.setState({ showMakePayment: true, isFuture: false });
		}
	}

	onPastPaymentListItmeClick(e, { data }) {
		this.setState({ selectedPastPaymentPolicy: data });
	}

	onMenuItemClick(e, { name }) {
		if (name === 'pay now') {
			return this.setState({ showMakePayment: true, isFuture: false });
		}

		if (name === 'make future payment') {
			return this.setState({ showMakePayment: true, isFuture: true });
		}

		this.setState({
			activeMenuItem: name,
		});
	}

	onAddRecurringPaymentClick(e, { data }) {
		if (data.billing.outstandingBalance > 0) {
			this.setState({ showCantChangeRecurring: true });
			return;
		}

		this.setState({ showRecurringPayment: true, recurringPaymentData: { isAdd: true, ...data } });
	}

	onRemoveRecurringPaymentClick(e, { data }) {
		this.setState({ showRemoveRecurring: true, removeRecurringData: data });
	}

	onRemoveRecurringPaymentCancel(e) {
		this.setState({ showRemoveRecurring: false });
	}

	async onRemoveRecurringPaymentContinue() {
		const { actions } = this.props;
		const { removeRecurringData } = this.state;
		const policy = removeRecurringData;
		const rcc = {
			payPlanId: 15,
			policyNumber: policy.policyNumber,
			policyId: policy.policyId,
			imageNumber: policy.policyImageNum,
			clientId: policy.clientId,
			userAgreedWithTerms: true,
		};
		try {
			await actions.removeRecurringPayment(rcc);
			this.setState({ showRemoveSuccess: true, showRemoveRecurring: false });
		} catch (error) {
			throw error;
		}
	}

	onFinishRemoveRecurringPayment() {
		const { actions, profile } = this.props;
		this.setState({ showRemoveRecurring: false, removeRecurringData: null, showRemoveSuccess: false });
		actions.getPolicies(profile.policies);
	}

	onEditRecurringPaymentClick(e, { data }) {
		if (data.billing.outstandingBalance > 0) {
			this.setState({ showCantChangeRecurring: true });
			return;
		}

		this.setState({ showRecurringPayment: true, recurringPaymentData: data });
	}

	onCloseCantChangeRecurring() {
		this.setState({ showCantChangeRecurring: false });
	}

	onRecurringPaymentClose(cancel) {
		const { actions, profile } = this.props;
		this.setState({ showRecurringPayment: false, recurringPaymentData: null });
		if (!cancel) actions.getPolicies(profile.policies);
	}

	render() {
		const { app, deepLink, onDeepLinkComplete, billingList } = this.props;
		const { activeMenuItem, selectedPastPaymentPolicy, showMakePayment, showRemoveRecurring, showRemoveSuccess, disabled, showCantChangeRecurring, isFuture, showRecurringPayment, recurringPaymentData } = this.state;
		const { policies, settings, payablePolicies } = this.props.payment;
		const { email, id } = this.props.profile;
		const { isWalletEnabled, isScheduledPaymentEnabled } = settings;
		const canMakePayment = (app.systemToggles || { canMakePayments: false }).canMakePayments;

		return (
			<Section name='payments' title='Payments' color='blue' mobileShow={this.props.mobileShow}>
				<Confirm open={showRemoveRecurring} header='Cancel Recurring Payment' content='Are you sure you want to cancel the recurring payment?' onConfirm={this.onRemoveRecurringPaymentContinue} onCancel={this.onRemoveRecurringPaymentCancel} />
				<Confirm cancelButton={false} confirmButton='Close' open={showRemoveSuccess} header='Cancel Recurring Payment' content='Your recurring payment information has been removed successfully.' onConfirm={this.onFinishRemoveRecurringPayment} />
				<Confirm open={showCantChangeRecurring} confirmButton='Close' header='Payment Required' content='Payplan changes are not allowed with a balance due.' onConfirm={this.onCloseCantChangeRecurring} cancelButton={false} />
				{showMakePayment && <AccountPayment open={showMakePayment} onPolicySelectionOpen={onDeepLinkComplete} selectedPolicyNumber={deepLink ? deepLink.policyNumber : null} onClose={() => this.setState({ showMakePayment: false })} disabled={disabled} isFuture={isFuture} canMakePayment={canMakePayment} policies={payablePolicies} payment={this.props.payment} paymentActions={this.props.actions} defaultEmailAddress={this.props.profile.email} />}
				{showRecurringPayment && <RecurringPayment open={showRecurringPayment} onClose={this.onRecurringPaymentClose} disabled={disabled} isFuture={isFuture} canMakePayment={canMakePayment} data={recurringPaymentData} payment={this.props.payment} paymentActions={this.props.actions} defaultEmailAddress={this.props.profile.email} />}
				<PaymentMenu activeItem={activeMenuItem} onClick={this.onMenuItemClick} isWalletEnabled={isWalletEnabled} isScheduledPaymentEnabled={isScheduledPaymentEnabled} />
				{activeMenuItem === 'policies' && <PaymentLists {...billingList} />}
				{activeMenuItem === 'past payments' && <PastPaymentInformation items={policies} onListItemClick={this.onPastPaymentListItmeClick} selectedPolicy={selectedPastPaymentPolicy} />}
                {activeMenuItem === 'monthly recurring payments' && <RecurringPayments actions={this.props.actions} items={payablePolicies} onAddClick={this.onAddRecurringPaymentClick} onEditClick={this.onEditRecurringPaymentClick} onRemoveClick={this.onRemoveRecurringPaymentClick} />}
				{activeMenuItem === 'wallet' && <Wallets actions={this.props.actions} policies={payablePolicies} wallets={this.props.payment.settings.wallets} payment={this.props.payment} userEmailAddress={email} userId={id} />}
				{activeMenuItem === 'scheduled payments' && <ScheduledPayments actions={this.props.actions} policies={payablePolicies} wallets={this.props.payment.settings.wallets} scheduledPayments={this.props.payment.scheduled} />}
			</Section>
		);
	}
}

PaymentSection.propTypes = {
	app: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	payment: PropTypes.object.isRequired,
	profile: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		app: appSelector(state),
		payment: paymentSelector(state),
		profile: profileSelector(state),
		billingList: paymentListSelector(state)
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators(paymentActions, dispatch),
		...bindActionCreators(policyActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSection);
